import React from 'react';
import {
  BadCard,
  BadDefaultContentText,
  BadDefaultSecondContentText,
  CardContent,
  CardTitle,
  DefaultCard,
  DefaultContentText,
  DefaultSecondContentText,
  GoodCard,
  GoodDefaultContentText,
  GoodDefaultSecondContentText,
  NormalCard,
  NormalDefaultContentText,
  NormalDefaultSecondContentText,
  TitleText,
} from './styles';

export const CARD_CONDITION_ENUM = {
  DEFAULT: 'default',
  BAD: 'bad',
  NORMAL: 'normal',
  GOOD: 'good',
};

function DefaultCarbonCard({
  iconPath,
  title,
  contentText,
  secondContentText,
  condition = CARD_CONDITION_ENUM.DEFAULT,
}) {
  if(condition === CARD_CONDITION_ENUM.BAD) {
    return (
      <BadCard>
        <CardTitle>
          <div>
            <img src={iconPath} width="24px" height="24px" alt="Icon" />
          </div>
          <TitleText>{title}</TitleText>
        </CardTitle>
        <CardContent>
          <BadDefaultContentText>{contentText}</BadDefaultContentText>
          <BadDefaultSecondContentText>{secondContentText}</BadDefaultSecondContentText>
        </CardContent>
      </BadCard>
    );
  }

  if(condition === CARD_CONDITION_ENUM.NORMAL) {
    return (
      <NormalCard>
        <CardTitle>
          <div>
            <img src={iconPath} width="24px" height="24px" alt="Icon" />
          </div>
          <TitleText>{title}</TitleText>
        </CardTitle>
        <CardContent>
          <NormalDefaultContentText>{contentText}</NormalDefaultContentText>
          <NormalDefaultSecondContentText>{secondContentText}</NormalDefaultSecondContentText>
        </CardContent>
      </NormalCard>
    );
  }

  if(condition === CARD_CONDITION_ENUM.GOOD) {
    return (
      <GoodCard>
        <CardTitle>
          <div>
            <img src={iconPath} width="24px" height="24px" alt="Icon" />
          </div>
          <TitleText>{title}</TitleText>
        </CardTitle>
        <CardContent>
          <GoodDefaultContentText>{contentText}</GoodDefaultContentText>
          <GoodDefaultSecondContentText>{secondContentText}</GoodDefaultSecondContentText>
        </CardContent>
      </GoodCard>
    );
  }

  return (
    <DefaultCard>
      <CardTitle>
        <div>
          <img src={iconPath} width="24px" height="24px" alt="Icon" />
        </div>
        <TitleText>{title}</TitleText>
      </CardTitle>
      <CardContent>
        <DefaultContentText>{contentText}</DefaultContentText>
        <DefaultSecondContentText>{secondContentText}</DefaultSecondContentText>
      </CardContent>
    </DefaultCard>
  );
}

export default DefaultCarbonCard;
